import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Bs4Tooltip from '../../Bs4Components/Bs4Tooltip';
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import { getBs4Style } from '../../Bs4Components/Bs4Utils'
import Bs4Stores from '../../Bs4Stores'
import Bs4MainDispatch from '../../Bs4MainDispatch'
import Bs4GenericField from './Bs4GenericField'


export default class Bs4OnOffSwitch extends Bs4GenericField {

  setValueBs4(value) {
    if (Array.isArray(value)) value = value[0];
    if (typeof value === 'undefined') value = null;
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    this.bs4Store = Bs4Stores.addUnknownValuesToStore(this.bs4Store, [value]);
    value = this.bs4Store.find(item => item.id == value);
    if (typeof value === 'undefined') value = null;
    this.setValue(value);
  }

  getValueBs4 () {    
    return this.getValue()?.id || '';
  }

  elementSetStore(store) {
    this.bs4Store = Array.isArray(store) ? store.map(item => ({id: item[0], name: item[1]})) : [];
    this.setValue(this.getValue());
  }

  isDifferentValues (oldValue, newVaue) {
    return oldValue?.id != newVaue?.id;
  }

  isNativelyClearable () {
    return true;
  }

  getShortValue = () => {
    return this.getValue()?.name;
  }

  ViewSummaryDetails = (props) => {
    const formField = this;
    return <formField.ViewComponentFieldSwitch SummaryDetails/>;
  }

  ViewOptionIcon = (props) => {
    const theme = useTheme();
    if (props?.option &&  !('bs4Style' in props.option)) props.option.bs4Style = getBs4Style(props?.option?.style) || null
    //if (props.option.bs4Style && !props.option.icon) props.option.icon = 'fa-regular fa-text';
    if (props.option.bs4Style && !props.option.icon) props.option.icon = 'fa-solid fa-circle';
    if (props.option?.icon) {
      return (
        <Bs4Tooltip arrow title={
          <React.Fragment>
            <Typography variant='body1'>{props?.option?.name}</Typography>
            <Typography variant='body2' sx={{whiteSpace: 'pre-line'}}>{props?.option?.text}</Typography>
          </React.Fragment>
          }
        >
          <Box 
            sx={{        
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              //width: 26, 
              //height: 26, 
              padding: 0.3,
              borderRadius: theme.shape.borderRadius+'px',
              ...props?.option?.bs4Style,
            }}
          >
            <Box className={props.option?.icon}/>
          </Box>
        </Bs4Tooltip>
      )       
    }
    return null
  };

  ViewOption = (props) => {
    const formField = this;    
    if (props?.option &&  !('bs4Style' in props.option)) props.option.bs4Style = getBs4Style(props?.option?.style) || null

    return (
      <Stack
        component='li'
        {...props.props}
        direction='row'
        justifyContent='flex-start'
        alignItems= 'flex-start'//'center'
        spacing={1}        
      >
        <formField.ViewOptionIcon option={props.option}/>
        <Stack component='span' direction='column' justifyContent='flex-start' alignItems='flex-start' spacing={0}>
          <Typography>{props?.option?.name}</Typography>
          {props?.option?.text ? <Typography variant='body2' sx={{whiteSpace: 'pre-line', opacity: 0.7}}>{props?.option?.text}</Typography> : null}
        </Stack>
      </Stack>
    )
  };

  ViewComponentField = (props) => {
    const formField = this;
    const [adornmentVisibility, setAdornmentVisibility] = React.useState('hidden');   
    
    const handleAdd = (e) => {
      Bs4MainDispatch.commandParser('Bs4FieldIconPlus', { currFormId: this.props.field.formId }, this.bs4KartotekaId);
    }

    return (
      <Box 
        width='100%'
        sx={{display: 'flex', alignItems: 'flex-end'}}
        onMouseEnter={() => setAdornmentVisibility('visible')} 
        onMouseLeave={() => setAdornmentVisibility('hidden')}
      >        
        <formField.ViewComponentFieldSwitch/>        
        {formField.isParamSelected('ATRYB_PLUS') &&
          <IconButton onClick={handleAdd}>
            <AddIcon fontSize='small' sx={{visibility: adornmentVisibility}}/>
          </IconButton> 
        }
      </Box>
    );
  }

  ViewComponentFieldSwitch = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [bs4Store, setBs4Store] = React.useState(() => formField.bs4Store || []);
    this.refFocus = React.useRef();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {
        setError({error: true, helperText: text})
      }

      const CHANGE = (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      };
      this.on(Bs4GenericField.CHANGE, CHANGE);
      
      const CHANGE_STORE = (bs4Store) => {
        setBs4Store(bs4Store);
        this.setValueBs4(this.getValueBs4());
      };
      this.on(Bs4GenericField.CHANGE_STORE, CHANGE_STORE);

      return () => {
        this.off(CHANGE);
        this.off(CHANGE_STORE);
      }
    }, [error, setError, setValue, setBs4Store]);

    const handleChange = (event, newValue) => {
      // console.log('...Switch...', newValue, value, bs4Store);
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(newValue ? bs4Store[1] : bs4Store[0]);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
      if (props.SummaryDetails) this.reloadGridCriteria();
    }    

    // console.log('...Switch...', value, value === bs4Store[1], bs4Store); 

    return (     
      <FormControl fullWidth error={error.error}>
        {(!this.props.field.hideLabel && !props.SummaryDetails) ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Switch
          ref={this.refFocus}
          disabled={this.readOnly}
          checked={value === bs4Store[1]}
          onChange={handleChange}        
        />     
      </FormControl>
    );
  }
}